/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetPendingTradesQueryVariables = Types.Exact<{
	assetId: Types.Scalars["ID"];
}>;

export type GetPendingTradesQuery = {
	__typename?: "Query";
	tradingOperationsInProgress: {
		__typename?: "TradingOperationInProgressResponse";
		affectedAssets?: Array<{
			__typename?: "AssetTradingOperationsInProgress";
			assetId: string;
			operations?: Array<{
				__typename?: "TradingOperationInProgress";
				type: Types.TradingOperationType;
				operationId: string;
			}> | null;
		} | null> | null;
	};
};

export const GetPendingTradesDocument = gql`
	query getPendingTrades($assetId: ID!) {
		tradingOperationsInProgress(assetId: $assetId) {
			affectedAssets {
				assetId
				operations {
					type
					operationId
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetPendingTradesGQLService extends Apollo.Query<GetPendingTradesQuery, GetPendingTradesQueryVariables> {
	document = GetPendingTradesDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
